import React from 'react'
import { LinkedInIcon, TwitterIcon, MailIcon, PhoneIcon, MapPinIcon } from '../../assets/icons'
import { getLinkProps } from '../../utils/navigation'
import { landingContent } from '../../config/content.config'
import TradeArrow from '../TradeArrow/TradeArrow'
import './Footer.css'

const iconMap = {
  LinkedInIcon: <LinkedInIcon />,
  TwitterIcon: <TwitterIcon />,
  MailIcon: <MailIcon />,
  PhoneIcon: <PhoneIcon />,
  MapPinIcon: <MapPinIcon />
}

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const { footer, features } = landingContent

  // Derive product links from features content
  const productLinks = features.main.map((feature) => ({
    label: feature.title,
    href: '#features'
  }))

  const handleNavClick = (e, link) => {
    const props = getLinkProps(link)
    if (props.target === '_blank') {
      // External links: let default behavior handle it
      return
    }

    // Internal links: smooth scroll
    if (link.href.startsWith('#')) {
      e.preventDefault()
      const element = document.querySelector(link.href)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      } else if (link.href === '#careers' || link.href === '#news' || link.href === '#privacy' || link.href === '#terms' || link.href === '#service') {
        alert('Page coming soon!')
      }
    }
  }

  return (
    <footer id="contact" className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="footer-logo-text">{footer.name}</span>
              <TradeArrow />
            </div>
            <p className="footer-description">
              {footer.description}
            </p>
            <div className="footer-social">
              {footer.social.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="footer-social-link"
                  aria-label={social.label}
                  {...getLinkProps(social)}
                >
                  {iconMap[social.icon]}
                </a>
              ))}
            </div>
          </div>

          {/* Product Links */}
          <div className="footer-links-column">
            <h4 className="footer-links-title">{footer.features.label}</h4>
            <ul className="footer-links">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="footer-link"
                    onClick={(e) => handleNavClick(e, link)}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div className="footer-links-column">
            <h4 className="footer-links-title">Company</h4>
            <ul className="footer-links">
              {footer.company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="footer-link"
                    onClick={(e) => handleNavClick(e, link)}
                    {...getLinkProps(link)}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            <a
              href={footer.copyright.href}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-copyright-link"
            >
              {footer.copyright.label.replace('{year}', currentYear)}
            </a>
          </p>
          <div className="footer-legal-links">
            {footer.legal.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="footer-legal-link"
                onClick={(e) => handleNavClick(e, link)}
                {...getLinkProps(link)}
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
